import { DataSource, DataSourceCodeConfig, DataSourceCrmConfig, DataSourceFileConfig, EDataSourceCategory } from '@/models/dataSource';
import { ChangeEvent, FC, useState } from 'react';
import { ChangeDataSourceNameButton } from './ChangeDataSourceNameButton';
import { useWorkspace } from '@/features/workspaces/hooks';
import { useWorkspaceAdmin } from '@/features/workspaces/hooks/useWorkspace';
import { prependHttp } from '@/utils';
import { useUpdateDataSourceMutation } from '@/services/dataSources';
import { DataSourceDetailName } from './DataSourceDetailName';

type DataSourceDetailEditableNameProps = {
  dataSource: DataSource;
};

export const DataSourceDetailEditableName: FC<DataSourceDetailEditableNameProps> = ({ dataSource }) => {
  const workspace = useWorkspace();
  const isWorkspaceAdmin = useWorkspaceAdmin();

  const [dataSourceName, setDataSourceName] = useState<string>(dataSource.name);
  const [isEditingName, setIsEditingName] = useState<boolean>(false);

  const [updateDataSource, { isLoading: isUpdateLoading }] = useUpdateDataSourceMutation();

  const handleDataSourceNameChange = (ev: ChangeEvent<HTMLInputElement>) => {
    setDataSourceName(ev.target.value);
  };

  const handleDataSourceRenameConfirm = async () => {
    if (dataSourceName === dataSource.name) {
      setIsEditingName(false);
      return;
    }

    const baseConfig = {
      workspaceId: workspace.id,
      dataSourceId: dataSource.id,
    };

    let datasourceConfiguration: unknown = {};
    switch (dataSource.type.category) {
      case EDataSourceCategory.CODE: {
        const configuration = dataSource.configuration as DataSourceCodeConfig;
        datasourceConfiguration = { ...configuration, url: prependHttp(configuration.url) };
        break;
      }

      case EDataSourceCategory.FILE: {
        const configuration = dataSource.configuration as DataSourceFileConfig;
        datasourceConfiguration = { ...configuration };
        break;
      }

      case EDataSourceCategory.CRM: {
        const configuration = dataSource.configuration as DataSourceCrmConfig;
        datasourceConfiguration = { ...configuration };
        break;
      }

      default:
        break;
    }

    await updateDataSource({
      ...baseConfig,
      dataSource: {
        name: dataSourceName,
        configuration: datasourceConfiguration,
      },
    });

    setIsEditingName(false);
  };

  return (
    <>
      <DataSourceDetailName dataSourceName={dataSource.name} isEditingName={isEditingName} onDataSourceNameChange={handleDataSourceNameChange} />
      {isWorkspaceAdmin && (
        <ChangeDataSourceNameButton
          isEditingName={isEditingName}
          isLoading={isUpdateLoading}
          onEditClick={() => setIsEditingName(true)}
          onDataSourceRenameConfirm={handleDataSourceRenameConfirm}
        />
      )}
    </>
  );
};
